import { render, staticRenderFns } from "./CustomerRegisterationInfo.vue?vue&type=template&id=1b7e7db8&"
import script from "./CustomerRegisterationInfo.vue?vue&type=script&lang=js&"
export * from "./CustomerRegisterationInfo.vue?vue&type=script&lang=js&"
import style0 from "./CustomerRegisterationInfo.vue?vue&type=style&index=0&id=1b7e7db8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports